export const BASE_URL = process.env.REACT_APP_BASE_URL;
//NODE_ENV === 'development' ? "http://localhost/Students_Affairs/backend/" : 'https://sis.ivyis.org/backend/';